<style scoped>
a:hover {
  text-decoration: underline;
}

div {
  /*border: 1px solid pink;*/
}
</style>

<template>
  <div style='font-size: 14px;'>
    <Confirm
      :show="deleteModal"
      :headerText="$text.tr('Удалить биржу') + ' ' + constants.exchangeNewIds[newExchId] + ' (' + name + ')?'"
      :text="$text.tr('Внимание! Активные сделки и боты, история торгов и статистика будут удалены с платформы.')"
      :btname="$text.tr('УДАЛИТЬ')"
      @on-cancel="deleteModal = false"
      @confirmed="remove"
      :warning="true"
    />
    <Modal
      width="700"
      v-model='$store.state.show.exchangeModal'
      :title='title'
      :loading='loading'
      @on-ok='ok'
      @on-cancel='cancel'
      style="text-align: center;"
    >
      <!--      <div v-if='$store.state.sys.demo'>После добавления, система переключится из демо в реальный режим<br>&nbsp;</div>-->

      <Select v-if="!this.$store.state.sys.demo" style="width: 300px;" v-model="newExchId" :disabled="editMode" :placeholder="$text.tr('Выбрать биржу')">
        <Option v-for="ex in exchanges" :key="'exchange-'+ex" :value="ex">
          {{ constants.exchangeNewIds[ex] }}
        </Option>
      </Select>

<!--      <RadioGroup-->
<!--        v-if="!this.$store.state.sys.demo"-->
<!--        v-model='newExchId'-->
<!--        type="button"-->
<!--      >-->
<!--        <Radio-->
<!--          v-for="ex in exchanges"-->
<!--          :key="'exchange-'+ex"-->
<!--          :label='ex'-->
<!--          size='small'-->
<!--          :disabled="editMode || $store.state.sys.demo"-->
<!--        >-->
<!--          <Icon type='social-apple'></Icon>-->
<!--          <span class='exlabel'>{{ constants.exchangeIds[ex] }}</span>-->
<!--        </Radio>-->
<!--      </RadioGroup>-->

<!--      <div v-if="newExchId === 'BYF' && editMode" style="margin-top: 20px; font-size: 20px;">-->
<!--        <div v-if="this.$store.state.sys.tradeExchange.sptnk === 'sg'" style="color: #259b77"></div>-->
<!--        <div v-else>-->
<!--          <div style="margin-bottom:20px;"><a style="color: var(&#45;&#45;color-info); font-size: 16px;" target="_blank" href="https://doc.capico.app/v/ru/new/obnovlenie-bybit-futures">Важная информация</a></div>-->
<!--          <Button style="width: 300px" :disabled="movingtosg" size="large" @click="movetosg">{{ movingtosg ? 'Ждите...' : 'Перейти на новый сервер' }}</Button>-->
<!--        </div>-->
<!--      </div>-->

      <div v-if="this.$store.state.sys.demo" style="margin-top: 20px; ">
        <a style="font-size: 16px; color: var(--color-info)"
           :href="$text.tr('https://doc.capico.app/v/ru/plans/demo')"
           target="_blank">
          {{ $text.tr('Инструкция') }}
        </a>
      </div>
      <div v-else style="margin-top: 20px; ">
        <a style="font-size: 16px; color: var(--color-info)"
           :href="$text.tr('https://doc.capico.app/v/ru/ex/api')"
           target="_blank">
          {{ $text.tr('Инструкция') }}
        </a>
      </div>

      <div style="margin-top: 20px">
        <div
          v-if="this.$store.state.sys.demo"
          style="font-size: 16px; margin-bottom: 38px"
        >{{ $text.tr('Используются данные биржи Binance') }}</div>
        <span
          v-else-if="newExchId === 'BIM'"
          style="font-size: 16px"
        >{{ $text.tr('Перед использованием') }} {{ $text.tr('маржинального счета') }},<br>{{ $text.tr('пожалуйста, ознакомьтесь с этой') }} <a
            style="color: var(--color-info)"
            :href="$text.tr('https://doc.capico.app/v/ru/ex/use/binance')"
            target="_blank"
          >{{ $text.tr('статьей') }}</a></span>
      </div>
      <div
        v-if="!this.$store.state.sys.demo"
        style="margin-top: 20px; height: 90px"
      >
        <div v-if="(newExchId === 'BIN' || newExchId === 'BIM' || newExchId === 'BIF') && !editMode">
          <i-switch
            v-model="binanceFree"
            style="margin-right: 8px; margin-bottom: 3px;"
            size="small"
          />
          <span style="font-size: 14px">{{ $text.tr('Использовать бесплатно.')}}
            <a
              v-if="newExchId !== 'BIF'"
              :href="$text.tr('https://doc.capico.app/v/ru/ex/api/binance')"
              target="_blank"
              style="color: var(--color-info)"
            >{{ $text.tr('Узнать как') }}</a>
            <a
              v-else
              :href="$text.tr('https://doc.capico.app/v/ru/ex/use/binance')"
              target="_blank"
              style="color: var(--color-info)"
            >{{ $text.tr('Узнать как') }}</a>
          </span>
          <i-input
            v-if="binanceFree"
            v-model='email'
            style='margin-top: 10px;'
            size='small'
            :maxlength="80"
          >
            <span slot='prepend'>
              <div style='font-size: 14px; width: 100px;'>Binance id
                <Icon
                  style="margin-top: -3px; cursor: pointer"
                  size=18
                  type="ios-information-circle-outline"
                  color="var(--color-text-dark)"
                  @click="openlink"
                />
              </div>
            </span>
          </i-input>
          <div
            v-if="binanceFree"
            class="yell"
            style="font-size: 15px; margin-top: 5px;"
          >{{ $text.tr('Внимание! Если ваш аккаунт не является реферальным,')}}<br>{{ $text.tr(' он будет отключен от платформы')}}</div>
        </div>
        <div v-if="(newExchId === 'HUO') && !editMode">
          <i-switch
            v-model="binanceFree"
            style="margin-right: 8px; margin-bottom: 3px;"
            size="small"
          />
          <span style="font-size: 14px">{{ $text.tr('Использовать бесплатно.')}} <a
              :href="$text.tr('https://doc.capico.app/v/ru/ex/api/huobi')"
              target="_blank"
              style="color: var(--color-info)"
            >{{ $text.tr('Узнать как') }}</a></span>
          <i-input
            v-if="binanceFree"
            v-model='email'
            style='margin-top: 10px;'
            size='small'
            :maxlength="80"
          >
            <span slot='prepend'>
              <div style='font-size: 14px; width: 120px;'>Huobi email/tel</div>
            </span>
          </i-input>
          <div
            v-if="binanceFree"
            class="yell"
            style="font-size: 15px; margin-top: 5px;"
          >{{ $text.tr('Внимание! Если ваш аккаунт не является реферальным,')}}<br>{{ $text.tr(' он будет отключен от платформы')}}</div>
        </div>
        <!--        <div v-else-if="!this.$store.state.sys.demo && newExchId === 'BIF' && !editMode">-->
        <!--          <i-switch v-model="binanceFree" style="margin-right: 8px; margin-bottom: 3px;" size="small"/>-->
        <!--          <span style="font-size: 14px">{{ $text.tr('Использовать бесплатно.')}} <a :href="$text.tr('https://capico.app/info/registration-futures/')" target="_blank" style="color: var(--color-info)">{{ $text.tr('Узнать как') }}</a></span><br>-->
        <!--          <span v-if="binanceFree" class="yell" style="font-size: 15px; margin-top: 5px;">{{ $text.tr('Внимание! Если ваш аккаунт не является реферальным,')}}<br>{{ $text.tr(' он будет отключен от платформы')}}</span>-->
        <!--        </div>-->
        <div v-if="(newExchId === 'BYF' || newExchId === 'BYB') && !editMode">
          <i-switch
            v-model="binanceFree"
            style="margin-right: 8px; margin-bottom: 3px;"
            size="small"
          />
          <span style="font-size: 14px">{{ $text.tr('Использовать бесплатно.')}} <a
            :href="$text.tr('https://doc.capico.app/v/ru/ex/api/bybit#besplatnoe-ispolzovanie')"
            target="_blank"
            style="color: var(--color-info)"
          >{{ $text.tr('Узнать как') }}</a></span>
          <div
            v-if="binanceFree"
            class="yell"
            style="font-size: 15px; margin-top: 5px;"
          >{{ $text.tr('Внимание! Если ваш аккаунт не является реферальным,')}}<br>{{ $text.tr(' он будет отключен от платформы')}}</div>
        </div>
        <div v-else-if="newExchId === 'FTX' && !editMode">
          <span style="font-size: 14px"><a
              :href="$text.tr('https://doc.capico.app/v/ru/ex/api/ftx')"
              target="_blank"
              style="color: var(--color-info)"
            >{{ $text.tr('Инструкция') }}</a> {{ $text.tr('по работе с биржей FTX')}}</span><br>
        </div>
      </div>
      <i-input
        v-model='name'
        style='margin-top: 20px;'
        size='large'
        :maxlength="14"
      >
        <span slot='prepend'>
          <div style='font-size: 14px; width: 70px;'>{{ $text.tr('Название')}}</div>
        </span>
      </i-input>
      <i-input
        v-model='apikey'
        v-if="!$store.state.sys.demo"
        style='margin-top: 20px;'
        :placeholder="editMode ? $text.tr('Введите новые ключи,') : ''"
        size='large'
      >
        <span slot='prepend'>
          <div style='font-size: 14px; width: 70px;'>API Key</div>
        </span>
      </i-input>
      <i-input
        v-model='apisecret'
        v-if="!$store.state.sys.demo"
        style='margin-top: 20px;'
        :placeholder="editMode ? $text.tr('если хотите их заменить') : ''"
        size='large'
      >
        <span slot='prepend'>
          <div style='font-size: 14px; width: 70px;'>API Secret</div>
        </span>
      </i-input>
      <i-input
        v-if="newExchId === 'FTX' && !editMode"
        v-model='subacc'
        style='margin-top: 20px;'
        size='large'
        :maxlength="30"
        :placeholder="$text.tr('оставить пустым для основного счета')"
      >
        <span slot='prepend'>
          <div style='font-size: 14px; width: 70px;'>{{ $text.tr('Субсчёт')}}</div>
        </span>
      </i-input>
      <i-input
        v-if="newExchId === 'OKX' || newExchId === 'GET' || newExchId === 'GEF'"
        v-model='subacc'
        style='margin-top: 20px;'
        size='large'
        :maxlength="30"
      >
        <span slot='prepend'>
          <div style='font-size: 14px; width: 70px;'>{{ $text.tr('Пароль')}}</div>
        </span>
      </i-input>
      <br>
      <div
        slot="footer"
        v-if="editMode"
        style="text-align: left;"
      >
        <Row>
          <i-col span="16">
            <Button
              type="warning"
              size="large"
              @click="deleteModal = true"
            >{{ $text.tr('УДАЛИТЬ') }}</Button>
          </i-col>
          <i-col
            span="8"
            style="text-align: right;"
          >
            <Button
              type="primary"
              size="large"
              @click="save"
            >{{ $text.tr('СОХРАНИТЬ') }}</Button>
          </i-col>
        </Row>
      </div>
    </Modal>
  </div>
</template>

<script>
import util from '@/util/util'
import Api from '@/util/api'
import Apis from '@/util/apis'
import SlimApi from '@/util/slimapi'
import SlimApis from '@/util/slimapis'
import constants from '@/util/constants'
import terminal from '@/services/terminal'
import Confirm from '@/components/common/Confirm'
import fastbot from '@/services/fastbot'
import axios from 'axios'
import { saveTradeExchange } from '@/store/index'

export default {
  name: 'ExchangeModal',
  components: { Confirm },
  watch: {
    '$store.state.show.exchangeModal': function (isShown) {
      if (isShown) {
        this.show()
      }
    }
  },
  data: function () {
    return {
      binanceFree: false,
      email: '',
      deleteModal: false,
      exchanges: ['GET', 'GEF', 'BYB', 'BYF', 'OKX', 'BIN', 'BIF', 'BIM', 'HUO', 'EXM'],
      title: 'Новая биржа',
      etid: '',
      name: '',
      apikey: '',
      apisecret: '',
      subacc: '',
      newExchId: '',
      editMode: false,
      loading: true,
      movingtosg: false,
      updateRatesInterval: null
    }
  },
  computed: {
    constants () {
      return constants
    }
  },
  methods: {
    openlink () {
      window.open(
        'https://capico.app/info/p/b2a57942-0359-4f96-be1c-86bc133d9cae',
        '_blank'
      )
    },
    validateEmail (email) {
      // eslint-disable-next-line
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    show () {
      if (this.$store.state.sys.demo) {
      }
      if (this.$store.state.show.exchangeModalIndex > -1) {
        const exch = this.$store.state.sys.tradeExchange
        // var exch = this.$store.state.sys.exchanges[this.$store.state.show.exchangeModalIndex]
        this.etid = exch.Id
        this.name = exch.Name
        this.apikey = ''
        this.apisecret = ''
        this.editMode = true
        this.newExchId = exch.ExchId
        if (this.$store.state.sys.demo) {
          this.title = this.$text.tr('Редактирование демо-счета')
        } else {
          this.title = this.$text.tr('Редактирование биржи')
        }
      } else {
        this.name = ''
        this.apikey = ''
        this.apisecret = ''
        this.newExchId = ''
        if (this.$store.state.sys.demo) {
          this.title = this.$text.tr('Новый демо-счет')
        } else {
          this.title = this.$text.tr('Новая биржа')
        }
        this.editMode = false
        this.binanceFree = false
      }
      this.subacc = ''
    },
    remove () {
      // if (confirm('Удалить биржу ' + this.name)) {
      //   // del it!
      // } else {
      //   return
      // }
      Apis[util.exchId2sputnik(this.$store.state.sys.tradeExchange.ExchId)].get('user/del_exch', {
        params: {
          token: this.$store.state.sys.token,
          etid: this.etid
        }
      })
        .then(response => {
          this.$store.dispatch('updateExchanges').then(() => {
            fastbot.updateFastbotExchangeAsync()

            if (this.$store.state.sys.exchanges.length === 0) {
              const currentDemo = this.$store.state.sys.demo
              const otherModeHasExchanges = this.$store.state.sys.allexchanges.some(
                exch => exch.Demo === !currentDemo
              )
              if (otherModeHasExchanges) {
                this.$store.commit('setDemoState', !currentDemo)
                this.$store.dispatch('updateExchanges').then(() => {
                  this.$store.state.show.exchangeModal = false
                  this.$Notice.info({
                    title: this.$text.tr('Последняя биржа удалена'),
                    desc: this.$text.tr(currentDemo ? 'Переключено в реальный режим' : 'Переключено в демо режим'),
                    duration: 5
                  })
                })
              }
            }
            this.$store.state.show.exchangeModal = false
          })
        })
        .catch(function (error) {
          console.log(error)
        })
      this.deleteModal = false
    },
    movetosg () {
      console.log('move to sg started')
      this.movingtosg = true

      // axios.get('https://sgtitan.capico.app/api/mgr/migrate', { // sgtest
      axios.get('https://sg.capico.app/api/mgr/migrate', {
        params: {
          etid: this.$store.state.sys.tradeExchange.Id,
          token: this.$store.state.sys.token
        }
      }).then(function (response) {
        console.log(response)
      }).catch(function (error) {
        console.log(error)
      })

      setTimeout(() => {
        this.$store.state.sys.tradeExchange.Id = 'y' + this.$store.state.sys.tradeExchange.Id
        this.$store.state.sys.tradeExchange.sptnk = 'sg'
        saveTradeExchange(this.$store.state.sys.tradeExchange, this.$store.state.sys.demo)
        window.location.reload()
      }, 5000) // todo 5000
    },
    save () {
      const params = {
        token: this.$store.state.sys.token,
        etid: this.etid,
        name: this.name
      }

      if (this.apikey !== '' || this.apisecret !== '') {
        if (this.apikey === '' || this.apisecret === '') {
          this.$Message.warning({
            content: this.$text.tr('Ошибка: неверный API key или API secret'),
            duration: 5
          })
          return
        }
        params.apikey = this.apikey
        params.secret = this.apisecret
      }

      if (this.newExchId === 'OKX' || this.newExchId === 'GET' || this.newExchId === 'GEF') {
        params.subacc = this.subacc
      }

      SlimApis[util.exchId2sputnik(this.$store.state.sys.tradeExchange.ExchId)].get('user/upd_exch', {
        params
      })
        .then(response => {
          if (response.data.err) {
            if (response.data.err === "apikey and secret aren't valid") {
              this.$Message.warning({
                content: this.$text.tr(
                  'Ошибка: неверный API key или API secret'
                ),
                duration: 5
              })
              this.modalError()
            } else if (response.data.err === 'wrong ref id') {
              const link = this.$text.tr('https://doc.capico.app/v/ru/plans/free')
              this.$Message.warning({
                content:
                  this.$text.tr(
                    'Аккаунт не соответствует требованиям бесплатного тарифа.'
                  ) +
                  ' <a href="' +
                  link +
                  '"style="color: var(--color-info)" target="_blank">' +
                  this.$text.tr('Подробнее') +
                  '<a>',
                duration: 10
              })
              this.modalError()
            } else if (response.data.err.toLowerCase().includes('unexpected end of json input')) {
              const supportUrl = this.$text.tr('https://t.me/capico_chat_ru')
              this.$Message.warning({
                content: this.$text.tr('Ошибка при обновлении API ключей. Проверьте корректность введённых данных и попробуйте ещё раз. Если ошибка повторяется, обратитесь в') +
                  ' <a href="' + supportUrl + '" style="color: var(--color-info)" target="_blank">' + this.$text.tr('поддержку') + '</a>',
                duration: 10
              })
              this.modalError()
            } else {
              this.$Message.warning({
                content: this.$text.tr('Ошибка') + ': ' + util.returnTextForErr(response.data.err),
                duration: 5
              })
              this.modalError()
            }
          } else {
            this.$store.dispatch('updateExchanges')
            this.$store.state.show.exchangeModal = false
            if (this.apikey !== '' && this.apisecret !== '') {
              this.$Notice.success({
                title: this.$text.tr('API ключи обновлены'),
                duration: 6
              })
            }
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    exchValue (eid) {
      if (this.$store.state.sys.exchValue[eid]) {
        switch (this.$store.state.sys.usdbtc) {
          case 'USD':
            return '$' + this.$store.state.sys.exchValue[eid].usd
          case 'BTC':
            return this.$store.state.sys.exchValue[eid].btc + ' BTC'
        }
      }
    },
    modalError () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    },
    async ok () {
      const ref = this

      if (this.$store.state.sys.demo) {
        if (this.name === '') {
          this.$Message.error(this.$text.tr('Ошибка: заполните все поля'))
          this.modalError()
          return
        }
        const prevIds = new Set(this.$store.state.sys.exchanges.map(e => e.Id))
        const err = await terminal.addDemoExch(this.name)
        if (err === 'reached limit of demo exchanges') {
          this.$Message.warning({
            content: this.$text.tr(
              'Достигнуто максимальное количество демо бирж'
            ),
            duration: 5
          })
        }
        await this.$store.dispatch('updateExchangesAsync')
        if (!this.editMode) {
          const newExch = this.$store.state.sys.exchanges.find(e => !prevIds.has(e.Id))
          if (newExch) {
            this.$store.state.sys.tradeExchange = newExch
            saveTradeExchange(newExch, this.$store.state.sys.demo)
          }
        }
        this.$store.state.show.exchangeModal = false
        return
      }

      if (
        this.apikey === '' ||
        this.apisecret === '' ||
        this.name === '' ||
        (this.newExchId === '' || this.newExchId === undefined) || // iView Select sets v-model to undefined (not '') when no option is selected
        (this.binanceFree &&
          (this.newExchId === 'BIN' ||
            this.newExchId === 'BIM' ||
            this.newExchId === 'HUO') &&
          this.email === '')
      ) {
        this.$Message.error(this.$text.tr('Ошибка: заполните все поля'))
        this.modalError()
        return
      }
      const params = {
        eid: this.newExchId,
        name: this.name,
        apikey: this.apikey,
        secret: this.apisecret
      }

      // var uri =
      //   'user/add_exch?token=' +
      //   this.$store.state.sys.token +
      //   '&eid=' +
      //   this.newExchId +
      //   '&name=' +
      //   this.name +
      //   '&apikey=' +
      //   this.apikey +
      //   '&secret=' +
      //   this.apisecret
      if (this.binanceFree && this.newExchId === 'HUO') {
        if (/^\+?\d+$/.test(this.email)) {
          if (this.email.length < 9) {
            this.$Message.error(
              this.$text.tr('Ошибка: введите правильный номер телефона')
            )
            this.modalError()
            return
          }
        } else if (!this.validateEmail(this.email)) {
          this.$Message.error(this.$text.tr('Ошибка: введите правильный email'))
          this.modalError()
          return
        }
        params.email = this.email
      } else if (this.newExchId === 'FTX' || this.newExchId === 'OKX' || this.newExchId === 'GET' || this.newExchId === 'GEF') {
        params.subacc = this.subacc
        params.email = 'free'
      } else if (
        this.binanceFree &&
        (this.newExchId === 'BIN' ||
          this.newExchId === 'BIM' ||
          this.newExchId === 'BIF')
      ) {
        // validate id
        if (!/^\d+$/.test(this.email) || this.email.length < 8) {
          this.$Message.error(
            this.$text.tr('Ошибка: введите правильный Binance id')
          )
          this.modalError()
          return
        }
        params.email = this.email
      }
      if (this.binanceFree && (this.newExchId === 'BYF' || this.newExchId === 'BYB')) {
        params.email = 'free'
      }

      const prevIds = new Set(this.$store.state.sys.exchanges.map(e => e.Id))
      SlimApis[util.exchId2sputnikOLD(this.newExchId)].post(`user/add_exch?token=${ref.$store.state.sys.token}&eid=${this.newExchId}&email=${params.email}`, params)
        .then(async function (response) {
          // console.log(response.data)
          // console.log(response.data.err)

          if (response.data.err) {
            if (response.data.err === "apikey and secret aren't valid") {
              ref.$Message.warning({
                content: ref.$text.tr(
                  'Ошибка: неверный API key или API secret'
                ),
                duration: 5
              })
              ref.modalError()
            } else if (response.data.err === 'reached limit of exchanges') {
              ref.$Message.warning({
                content: ref.$text.tr(
                  'Достигнуто максимальное количество бирж'
                ),
                duration: 5
              })
              ref.$store.state.show.exchangeModal = false
            } else if (response.data.err === 'cannot change position mode') {
              const link = ref.$text.tr(
                'https://doc.capico.app/v/ru/ex/use/binance'
              )
              ref.$Message.warning({
                content:
                  ref.$text.tr(
                    'Чтобы подключить ключ, переключитесь в режим хеджирования.'
                  ) +
                  ' <a href="' +
                  link +
                  '"style="color: var(--color-info)" target="_blank">' +
                  ref.$text.tr('Инструкция') +
                  '<a>',
                duration: 10
              })
              ref.modalError()
            } else if (response.data.err === 'wrong ref id') {
              const link = ref.$text.tr('https://doc.capico.app/v/ru/plans/free')
              ref.$Message.warning({
                content:
                  ref.$text.tr(
                    'Аккаунт не соответствует требованиям бесплатного тарифа.'
                  ) +
                  ' <a href="' +
                  link +
                  '"style="color: var(--color-info)" target="_blank">' +
                  ref.$text.tr('Подробнее') +
                  '<a>',
                duration: 10
              })
              ref.modalError()
            } else {
              ref.$Message.warning({
                content: ref.$text.tr('Ошибка') + ': ' + util.returnTextForErr(response.data.err),
                duration: 5
              })
              ref.modalError()
            }
          } else {
            await ref.$store.dispatch('updateExchangesAsync')
            if (!ref.editMode) {
              const newExch = ref.$store.state.sys.exchanges.find(e => !prevIds.has(e.Id))
              if (newExch) {
                ref.$store.state.sys.tradeExchange = newExch
                saveTradeExchange(newExch, ref.$store.state.sys.demo)
              }
            }
            await fastbot.updateFastbotExchangeAsync()
            // ref.$store.state.sys.demo = false
            ref.email = ''
            ref.$store.state.show.exchangeModal = false
            ref.$Notice.success({
              title: ref.$text.tr('Биржа добавлена'),
              duration: 6
            })
          }
        })
        .catch(function (error) {
          console.log(error)
          ref.$Message.error(ref.$text.tr('Ошибка'))
          ref.modalError()
        })
    },
    cancel () {
      // this.$Message.info('Clicked cancel')
      const currentDemo = this.$store.state.sys.demo
      const currentModeHasExchanges = this.$store.state.sys.exchanges.length > 0
      const otherModeHasExchanges = this.$store.state.sys.allexchanges.some(
        exch => exch.Demo === !currentDemo
      )
      if (!currentModeHasExchanges && otherModeHasExchanges) {
        // Current mode has no exchanges but other does — switch to other mode
        this.$store.commit('setDemoState', !currentDemo)
        this.$store.dispatch('updateExchanges').then(() => {
          this.$Notice.info({
            title: this.$text.tr('Биржа не добавлена'),
            desc: this.$text.tr(currentDemo ? 'Переключено в реальный режим' : 'Переключено в демо режим'),
            duration: 5
          })
        })
      }
    }
  }
}
</script>
